<div class="row mt-3" *ngIf="hasRentals">
  <div class="col-sm-12">
    <tan-table [data]="rentals" [loading]="(rentalsLoading$ | async)" [error]="(rentalsError$ | async)"
      [filterConfigItems]="filterDropdownOptions" [iconClass]="iconClass" [totalPages]="pageCount"
      [itemCount]="itemCount" [currentPage]="currentPage" (onPageClick)="paginate($event)"
      (onClickViewItem)="viewItem($event)" (onClickRetry)="retry()" [canBulkEdit]="false" [columnConfig]="columnConfig"
      [page]="'rentals'" (searchTerm)="search($event)" (onFilter)="filter($event)" (onClickSort)="sort($event)">
    </tan-table>
  </div>
</div>